const valuePropCardContent = {
  displayField: 'cardHeadline',
  name: 'Value Prop Card Content',
  description: '',
  fields: [
    {
      id: 'cardImage',
      name: 'Card Image',
      type: 'Link',
      localized: false,
      required: true,
      validations: [
        { linkMimetypeGroup: [ 'image' ] },
        { assetFileSize: { min: null, max: 102400 } }
      ],
      disabled: false,
      omitted: false,
      linkType: 'Asset'
    },
    {
      id: 'cardHeadline',
      name: 'Card Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'cardSubHeadline',
      name: 'Card Sub-headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'cardDescription',
      name: 'Card Description',
      type: 'Symbol',
      localized: true,
      required: true,
      validations: [],
      disabled: false,
      omitted: false
    }
  ],
  sys: {
    id: 'valuePropCardContent',
    version: 12,
    updatedAt: '2023-08-03T14:42:02.561Z'
  }
};
export default valuePropCardContent;